import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, Sprout } from 'lucide-react';
import { toast } from 'sonner';
import FormularioFamilia from '../../components/FormularioFamilia';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CadastroPais = () => {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (data) => {
    setSubmitting(true);
    try {
      const res = await axios.post(`${API}/families/register-public`, data);
      toast.success('Familia cadastrada com sucesso!');
      // Auto-login
      if (res.data.token) {
        localStorage.setItem('parent_token', res.data.token);
        localStorage.setItem('parent_name', res.data.parent_name);
        navigate('/app-pais/dashboard');
      }
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erro ao cadastrar');
    }
    setSubmitting(false);
  };

  return (
    <div className="min-h-screen bg-[#F9F9F7] pb-12">
      <div className="bg-[#1A4D2E] text-white px-4 py-6">
        <div className="max-w-lg mx-auto">
          <button onClick={() => navigate(-1)} className="hover:bg-white/10 rounded-full p-2 transition-all mb-2" data-testid="back-btn">
            <ArrowLeft className="w-5 h-5" />
          </button>
          <div className="flex items-center gap-3">
            <Sprout className="w-7 h-7" />
            <div>
              <h1 className="font-nunito font-bold text-2xl">Cadastro da Familia</h1>
              <p className="font-inter text-white/70 text-sm mt-1">Preencha os dados para acessar o Portal da Familia</p>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-lg mx-auto px-4 py-6">
        <FormularioFamilia
          onSubmit={handleSubmit}
          submitting={submitting}
          submitLabel="Cadastrar Familia"
        />
      </div>
    </div>
  );
};

export default CadastroPais;
